import { Logger } from "@rogoag/shared-ts";
import { IS_DEV_SENTRY, IS_PROD } from "./constants";
export const logger = new Logger({
	application: "Portal Web",
	entrypoint: "logger.ts",
	isProduction: IS_PROD || IS_DEV_SENTRY,
	enableConsoleLogging: IS_DEV_SENTRY,
	verboseConsole: false,
	enableSentryLogging: IS_PROD || IS_DEV_SENTRY,
});
